import { handleActions } from "redux-actions";

import sort from "utils/incentives/sort";
import removeById from "utils/removeById";

const incentiveReducer = handleActions(
  {
    ASSET_INCENTIVES_GET_FULFILLED: (_, { payload: { incentives } }) => ({
      assetIncentives: sort(incentives),
    }),

    ASSET_INCENTIVE_ASSIGN_PENDING: ({ assetIncentives, incentives }, { meta: { incentive } }) => ({
      assetIncentives: sort([...assetIncentives, incentives.find((i) => i.id === incentive.id)]),
    }),

    ASSET_INCENTIVE_UNASSIGN_PENDING: ({ assetIncentives }, { meta: { incentive } }) => ({
      assetIncentives: removeById(assetIncentives, incentive.id),
    }),
  },
  {},
  { namespace: "_" }
);

export default incentiveReducer;
